<template>
  <div class="mt-8"></div>
</template>
<script lang="ts">
import { defineComponent } from "vue";


export default defineComponent({
  name: "RedPadelRedirect",
  mounted() {
    if(this.$route.query){
      const query = this.$route.query;
      window.parent.postMessage(query, process.env.VUE_APP_URL);
      return;
    }
  },
});
</script>